import fordImage from "./images/fordGuestBoard.svg";

const FordGuestBoardImageComponent = (props:any) => {
    const {classes}=props;
    return (
        <img
            className={classes.fordImage}
            alt="Logo"
            src={fordImage}
            style={{display:'flex',height:"100%"}}
        />
    )
}

export default FordGuestBoardImageComponent;